
<h3 class="page-title">Release notes</h3>
<button class="btn btn-lg-close" (click)="modalInstance.close()">&times;<span class="sr-only" translate>Close</span></button>
<div *ngFor="let note of notes">
  <button class="btn btn-secondary btn-lg btn-block header" (click)="expanded[note.version] = !expanded[note.version]" [class.active]="expanded[note.version]"><i class="far fa-fw fa-chevron-right" *ngIf="!expanded[note.version]"></i><i class="far fa-fw fa-chevron-down" *ngIf="expanded[note.version]"></i>
    <translate>Version {{note.version}}</translate>
  </button>
  <div class="body" *ngIf="expanded[note.version]" [innerHTML]="note.html"></div>
</div>